package com.milta.feature.route.domain.entity

/**
 * A2 — generic, server-set reason of a Failed stop (`failureReason` of
 * `GET /routes/{id}/proofs`), distinct from the driver's free-text `comment`. Decoded through
 * [fromWire] rather than a direct enum serializer so a value added later by the backend degrades to
 * "no generic label" instead of failing the whole proofs response (the Json client has no
 * `coerceInputValues`).
 */
enum class FailureReason(val wireValue: String) {
    /** Route closed by the driver with stops still Pending — imputed to the carrier. */
    RouteClosedByDriver("RouteClosedByDriver"),
    ;

    companion object {
        fun fromWire(value: String?): FailureReason? = entries.firstOrNull { it.wireValue == value }
    }
}
